import React, { useState, useEffect, useRef } from "react";
import "./Navbar.css";
import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";
import { FaChevronDown, FaChevronUp, FaChevronRight } from "react-icons/fa";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const aboutRef = useRef(null);
  const offeringsRef = useRef(null);
  const sustainabilityRef = useRef(null);
  const productsRef = useRef(null);
  const contactRef = useRef(null);
  const navigate = useNavigate();

  const [openSubMenu, setOpenSubMenu] = useState(null);

  // Close all dropdowns
  const closeAllDropdowns = () => {
    setOpenMenu(null);
  };

  // Common smooth scroll or navigate
  const goToSection = (sectionId) => {
    if (window.location.pathname === "/") {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } else {
      navigate("/");
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }, 500);
    }
    setMobileMenuOpen(false);
  };

  const closeAll = () => setOpenMenu(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 768);
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        aboutRef.current &&
        !aboutRef.current.contains(e.target) &&
        offeringsRef.current &&
        !offeringsRef.current.contains(e.target) &&
        sustainabilityRef.current &&
        !sustainabilityRef.current.contains(e.target) &&
        productsRef.current &&
        !productsRef.current.contains(e.target) &&
        contactRef.current &&
        !contactRef.current.contains(e.target)
      ) {
        closeAll();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Helper for hover with small delay
let timeoutId;
const handleMouseEnter = (menu) => {
  if (isMobile) return;
  clearTimeout(timeoutId);
  setOpenMenu(menu);
};
const handleMouseLeave = () => {
  if (isMobile) return;
  timeoutId = setTimeout(() => setOpenMenu(null), 150);
};
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        aboutRef.current &&
        !aboutRef.current.contains(e.target) &&
        offeringsRef.current &&
        !offeringsRef.current.contains(e.target) &&
        contactRef.current &&
        !contactRef.current.contains(e.target)
      ) {
        closeAllDropdowns();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Helper to navigate + close mobile menu together
const goTo = (path) => {
  closeAllDropdowns();
  setMobileMenuOpen(false);

  navigate(path);

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "auto",
  });
};
  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div
        className="logo"
        onClick={() => goToSection("hero")}
        style={{ cursor: "pointer" }}
      >
        <img src={logo} alt="Logo" />
      </div>

      {/* HAMBURGER — mobile only */}
      <button
        className="hamburger-btn"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Toggle menu"
      >
        {mobileMenuOpen ? "\u2715" : "\u2630"}
      </button>

      <div className={`nav-collapse ${mobileMenuOpen ? "open" : ""}`}>

        {/* TOP RIGHT LINKS */}
        <div className="top-right-links">
          <button className="contactus-link-btn" onClick={() => goTo("/contactus")}>Contact Us</button>
          <button className="investors-link-btn" onClick={() => goTo("/investors")}>Investors</button>
        </div>


        <div className="nav-buttons lower-menu">
          <button className="aboutus-btn" onClick={() => goToSection("hero")}>
            Home
          </button>

          <div
            className="dropdown"
            ref={aboutRef}
            onMouseEnter={() => handleMouseEnter("about")}
            onMouseLeave={handleMouseLeave}
          >
            <button
              className={`aboutus-btn ${openMenu === "about" ? "active" : ""}`}
              onClick={() =>
                setOpenMenu(openMenu === "about" ? null : "about")
              }
            >
              About Us{" "}
              {openMenu === "about" ? <FaChevronUp className="submenu-icon-svg" /> : <FaChevronDown className="submenub-icon-svg" />}
            </button>

            {openMenu === "about" && (
              <div className="dropdown-box1">
                <button
                  className="dropdown-item1"
                  onClick={() => goTo("/founder")} id="scl-profile"
                >
                  Founder
                </button>
                <button
                  className="dropdown-item1"
                  onClick={() => goTo("/vision")} id="vision"
                >
                  Vision & Mission
                </button>
                <button
                  className="dropdown-item1"
                  onClick={() => goTo("/journey")} id="journey"
                >
                  Our Journey
                </button>
                <button
                  className="dropdown-item1"
                  onClick={() => goTo("/footprint")} id="glo-foot"
                >
                  Global Footprint
                </button>
                {
                <button
                  className="dropdown-item1"
                  onClick={() => goTo("/directors")} id="directors"
                >
                  Board of Directors
                </button>
                }
                <button
                  className="dropdown-item1"
                  onClick={() => goTo("/practices")} id="practices"
                >
                  TQM Practices
                </button>
                <button
                  className="dropdown-item1"
                  onClick={() => goTo("/awards")} id="awards"
                >
                  Awards & Recognition
                </button>
                <button
                  className="dropdown-item1"
                  onClick={() => goTo("/certifications")} id="certificates"
                >
                  Certifications
                </button>
                <button
                  className="dropdown-item1"
                  onClick={() => goTo("/commitment")} id="commit"
                >
                  CSR-SST
                </button>
              </div>
            )}
          </div>

          <div
            className="dropdown"
            ref={offeringsRef}
            onMouseEnter={() => handleMouseEnter("offerings")}
            onMouseLeave={handleMouseLeave}
          >
            <button
              className={`capabilities-btn ${openMenu === "offerings" ? "active" : ""
                }`}
              onClick={() =>
                setOpenMenu(openMenu === "offerings" ? null : "offerings")
              }
            >
              Our Offerings{" "}
              {openMenu === "offerings" ? (
                <FaChevronUp className="submenu-icon-svg" />
              ) : (
                <FaChevronDown className="submenub-icon-svg" />
              )}
            </button>

            {openMenu === "offerings" && (
              <div className="dropdown-box2">

                {/* SOLUTIONS */}
                <div
  className="dropdown-item-wrapper"
  onMouseEnter={() => !isMobile && setOpenSubMenu("solutions")}
>
  <div
    className="dropdown-item-inner"
    onClick={() => goTo("/solutions")}
  >
    <span className="dropdown-text">Solutions</span>
    <FaChevronRight
      className={`submenu-icon ${openSubMenu === "solutions" ? "rotate" : ""}`}
      onClick={(e) => {
        e.stopPropagation();
        setOpenSubMenu(openSubMenu === "solutions" ? null : "solutions");
      }}
    />
  </div>

  {openSubMenu === "solutions" && (
    <div className="sub-dropdown">
      <button onClick={() => goTo("/solutions/sol-design")}>
        Design
      </button>
      <button onClick={() => goTo("/solutions/sol-prototyping")}>
        Prototyping
      </button>
      <button onClick={() => goTo("/solutions/sol-eng")}>
        Engineering
      </button>
    </div>
  )}
</div>

                {/* TECHNOLOGY */}
                           <div
  className="dropdown-item-wrapper"
  onMouseEnter={() => !isMobile && setOpenSubMenu("technology")}
>
  <div
    className="dropdown-item-inner"
    onClick={() => goTo("/technology")}
  >
    <span className="dropdown-text">Technology</span>
    <FaChevronRight
      className={`submenu-icon ${openSubMenu === "technology" ? "rotate" : ""}`}
      onClick={(e) => {
        e.stopPropagation();
        setOpenSubMenu(openSubMenu === "technology" ? null : "technology");
      }}
    />
  </div>

  {openSubMenu === "technology" && (
    <div className="sub-dropdown">
      <button onClick={() => goTo("/technology/tech-process")}>
        Process
      </button>
      <button onClick={() => goTo("/technology/tech-product")}>
        Product
      </button>
      <button onClick={() => goTo("/technology/tech-digital")}>
        Digital
      </button>
    </div>
  )}
</div>

                {/* CAPABILITIES */}
                <div
  className="dropdown-item-wrapper"
  onMouseEnter={() => !isMobile && setOpenSubMenu("capabilities")}
>
  <div
    className="dropdown-item-inner"
    onClick={() => goTo("/capabilities")}
  >
    <span className="dropdown-text">Capabilities</span>
    <FaChevronRight
      className={`submenu-icon ${openSubMenu === "capabilities" ? "rotate" : ""}`}
      onClick={(e) => {
        e.stopPropagation();
        setOpenSubMenu(openSubMenu === "capabilities" ? null : "capabilities");
      }}
    />
  </div>

  {openSubMenu === "capabilities" && (
    <div className="sub-dropdown">
      <button onClick={() => goTo("/capabilities/cap-research")}>
        Research & Development
      </button>
      <button onClick={() => goTo("/capabilities/cap-manufacture")}>
        Manufacturing
      </button>
      <button onClick={() => goTo("/capabilities/cap-quality")}>
        Quality
      </button>
    </div>
  )}
</div>
              </div>
            )}

          </div>

          <div
            className="dropdown"
            ref={productsRef}
            onMouseEnter={() => handleMouseEnter("products")}
            onMouseLeave={handleMouseLeave}
          >
            <button
              className={`capabilities-btn ${openMenu === "products" ? "active" : ""
                }`}
              onClick={() =>
                setOpenMenu(openMenu === "products" ? null : "products")
              }
            >
              Products{" "}
              {openMenu === "products" ? (
                <FaChevronUp className="submenu-icon-svg" />
              ) : (
                <FaChevronDown className="submenub-icon-svg" />
              )}
            </button>

            {openMenu === "products" && (
              <div className="dropdown-box2">
                <button className="dropdown-item2" onClick={() => goTo("/commercial")}>
                  Commercial Vehicles
                </button>
                <button className="dropdown-item2" onClick={() => goTo("/passenger")}>
                  Passenger Vehicles
                </button>
                 <button className="dropdown-item2" onClick={() => goTo("/twowheelers")}>
                  Others
    </button>
                
              </div>
            )}
          </div>

          <button className="aboutus-btn" onClick={() => goTo("/customers")}>Customers</button>

          <div
            className="dropdown"
            ref={sustainabilityRef}
            onMouseEnter={() => handleMouseEnter("sustainability")}
            onMouseLeave={handleMouseLeave}
          >
            <button
              className={`capabilities-btn ${openMenu === "sustainability" ? "active" : ""
                }`}
              onClick={() =>
                setOpenMenu(
                  openMenu === "sustainability" ? null : "sustainability"
                )
              }
            >
              Sustainability{" "}
              {openMenu === "sustainability" ? (
                <FaChevronUp className="submenu-icon-svg" />
              ) : (
                <FaChevronDown className="submenub-icon-svg" />
              )}
            </button>

            {openMenu === "sustainability" && (
              <div className="dropdown-box2">
                <button className="dropdown-item2" onClick={() => goTo("/Environmental")}>
                  Environment
                </button>
                <button className="dropdown-item2" onClick={() => goTo("/SocialSustainability")}>
                  Social
                </button>
              </div>
            )}
          </div>

          <div
            className="dropdown"
            onMouseEnter={() => handleMouseEnter("people")}
            onMouseLeave={handleMouseLeave}
          >
            <button
              className={`aboutus-btn ${openMenu === "people" ? "active" : ""
                }`}
              onClick={() =>
                setOpenMenu(openMenu === "people" ? null : "people")
              }
            >
              People{" "}
              {openMenu === "people" ? (
                <FaChevronUp className="submenu-icon-svg" />
              ) : (
                <FaChevronDown className="submenu-icon-svg" />
              )}
            </button>

            {openMenu === "people" && (
              <div className="dropdown-box2 people-dropdown">
                <button
                  className="dropdown-item2"
                  onClick={() => goTo("/peo-culture")} id="peo-cul"
                >
                  Culture at SCL
                </button>

                <button
                  className="dropdown-item2"
                  onClick={() => goTo("/peo-career")} id="peo-car"
                >
                  Careers
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
